import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "A Bit of Background",
description: "Explains the origins and design philosophy behind Freon, including principles like simplicity, modularity, and openness. Covers minimal viable product thinking, name-based references, model units, and other key guidelines.",
tags: [ "Freon", "background", "design philosophy", "minimal viable product", "Pareto principle", "name-based references", "model units", "modularity", "DSL", "language engineering", "documentation"] ,
modifiedTime: "2025-11-07T18:48:10.991Z",
publishedTime: "2025-11-07T17:20:18.647Z"
    }
  };
};